import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-manual-create-player',
  templateUrl: './manual-create-player.component.html',
  styleUrls: ['./manual-create-player.component.scss']
})
export class ManualCreatePlayerComponent implements OnInit {

  public data:any = {};
  public player_id_data: any = {status: 1};

  @Input() set setData(v:any) {
    this.data = v;

    if(this.data.username) {
      this.player_id_data.username = this.data.username;
    }
    if(this.data.password) {
      this.player_id_data.password = this.data.password;
    }

    if(this.data.player_status) {
      this.player_id_data.status = this.data.player_status;
    }

    if(this.data.player_game_id) {
      this.player_id_data.id = this.data.player_game_id;
    }

  }

  @Output() getPlayerGameID = new EventEmitter()
  constructor(private http: HttpService) { }

  ngOnInit(): void {
  }


  async updatePlayerGameID() {
    const data = this.player_id_data;
    data.player_uuid = this.data.player_uuid
    data.game_id = this.data.game_id
    data.company_uuid = this.data.company_uuid
    data.manual_tenant_origin_uuid = this.data.manual_tenant_origin_uuid
    let y:any = await this.http.post("/admin/player/id/update", data);
    this.getPlayerGameID.emit(y.player_game_id)
  }

}
